<script>
  import resources from './resources'

  export default {
    name: 'gadget-active-agenda',
    mixins: [resources]
  }
</script>

<template lang="pug">
  section.gadget-agenda-ativa.white-bg.wrapper.full-width.gadget
    modal(
      :visible="showModalAvailable",
      :name="'schedule_reserved' + currentSchedule.id",
      height="auto",
      @close="hideShowModalAvailable"
    )
      available(v-if="showModalAvailable", :schedules="schedulesSelected", @close="onCloseAvailable")
        
    modal(
      :visible="showModalReserved",
      :name="'schedule_reserved' + currentSchedule.id",
      height="auto",
      @close="hideShowModalReserved"
    )
      reserved(v-if="showModalReserved", :schedules="schedulesSelected", @close="onCloseReserved")

    modal(
      :visible="showModalReverser",
      :name="'schedule_reverser' + currentSchedule.id",
      height="auto",
      @close="hideShowModalReverser"
    )
      reverser(v-if="showModalReverser", :schedule="currentSchedule", @close="onCloseReverser")

    modal(
      :visible="showModalTransfer",
      :name="'schedule_transfer' + currentSchedule.id",
      height="auto",
      @close="hideShowModalTransfer"
    )
      transfer(v-if="showModalTransfer", :schedule="currentSchedule", @close="onCloseTransfer")

    modal(
      :visible="showModalFromDelayedRollback",
      name="schedule_from_delayed",
      height="auto",
      @close="hideShowModalFromDelayedRollback"
    )
      rollback-from-delayed(v-if="showModalFromDelayedRollback", :schedules="schedulesSelected", @close="onCloseFromFromDelayedRollback")

    modal(
        :visible="showModalInAttendance",
        name="schedule_from_delayed",
        height="auto",
        @close="hideShowModalInAttendance"
      )
      in-attendance(v-if="showModalInAttendance", :schedules="schedulesSelected", @close="onCloseInAttendance")

    modal(
      :visible="showModalPresent",
      name="schedule_present",
      height="auto",
      @close="hideShowModalPresent"
      )
      present(v-if="showModalPresent", :schedules="schedulesSelected", @close="onClosePresent")


    modal(
      :visible="showModal",
      className="paciente",
      v-if="showModal",
      @close="showModal = false"
      )
      appointment-details(:schedule="currentSchedule",:professionalCurrent="currentProfessional")

    modal(
      :visible="showModalCancel",
      name="schedule_canceled",
      height="auto",
      @close="hideShowModalCancel"
    )
      cancel(v-if="showModalCancel", :schedules="schedulesSelected", @close="onCloseCancel")

    modal(
      :visible="showModalDelayed",
      name="schedule_delayed",
      height="auto",
      @close="hideShowModalDelayed"
    )
      delayed(v-if="showModalDelayed", :schedules="schedulesSelected", @close="onCloseDelayed")

    modal(
      :visible="showModalConfirmed",
      name="schedule_confirmed",
      height="auto",
      @close="hideshowModalConfirmed"
    )
      confirmed(v-if="showModalConfirmed", :schedules="schedulesSelected", @close="onCloseConfirmed")

    modal(
      :visible="showModalAbsent",
      :name="'schedule_transfer' + currentSchedule.id",
      height="auto",
      @close="hideShowModalAbsent"
    )
      absent(v-if="showModalAbsent", :schedules="schedulesSelected", @close="onCloseAbsent")

    modal(
      :visible="showModalRollback",
      name="schedule_rollback",
      height="auto",
      @close="hideShowModalRollback"
    )
      rollback(v-if="showModalRollback", :schedules="schedulesSelected", @close="onCloseRollback")

    .gadget-title
      | Listagem de Agendas - Integração Offline
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    .col-md-6
      label.light-red Selecione uma Agenda
      //-- Removido este parametro que auto seleciona @received="setFirstAgenda",
      f-select-professional-agenda(
        v-model="agenda_id",
        :parameters="{active: true, includes: ['next_30dates','professional']}",
        :parameters-show="{includes: ['next_30dates','professional']}",
        :get-all="true",
        :searchable="false",
        @received="setFirstAgenda",
        @selected="selectedAgendaAvailable")

    .col-md-6
      label.light-red Data
      f-select(
        v-model="date",
        :options="dates"
      )
    .clearfix
    div(style='margin-top:15px;')
      .col-xs-12.col-sm-4.col-md-3(v-if="false")
        label.light-red Dia da Semana
        h4.medium-gray Seg-Qua-Sex
      .col-xs-12.col-sm-4.col-md-3(v-if="false")
        label.light-red Período de Atendimento
        h4.medium-gray 8h - 12h | 14h - 16h
      .col-xs-12.col-sm-4.col-md-2(v-if="false")
        label.light-red
          | Intervalo
          small (minutos)
        h4.medium-gray 30
      .col-xs-12.col-md-4(v-if="false")
        label.light-red Situação da Agenda
        .percentage-graph
          // Base
          .base
            .text 25% Preenchida
          // Cor
          .color(style='width:25%;')
            .text
              | 25% Preenchida
    .clearfix
    //- pre {{ agenda.schedules_integration_offline }}
    div(style='margin-top:15px;', v-if="agenda.schedules.length !== 0")
      .col-xs-12.col-sm-6.col-md-3
        label.light-red Unidade de Atendimento
        h4.medium-gray {{ agenda.address.name }}
      .col-xs-12.col-sm-6.col-md-9
        label.light-red Localização
        h4.medium-gray {{ agenda.address.label }} - {{ agenda.address.label2 }}
    div(v-if="loading")
      h2
        center Carregando...
    div(v-if="agenda.schedules.length <= 0 && !loading")
      h2
        center Nenhuma agenda selecionada.
    div(v-if="agenda.schedules.length > 0 && !loading")
      .table.col-xs-12
        .row.hidden-xs.hidden-sm
          .col-xs-12.col-sm-1.col-title Hora
          .col-xs-12.col-sm-4.col-title Paciente
          .col-xs-12.col-sm-3.col-title Convênio
          .col-xs-12.col-sm-3.col-title Status
          .col-xs-12.col-sm-1.col-title Ação
        .order-by.hidden-md.hidden-lg
          | Ordenar por
          span
            select.ordenar-por(name='Ordenar por')
              option(value='Hora') Hora
              option(value='Paciente') Paciente
              option(value='Convênio') Convênio
              option(value='Status Atendimento') Status
        ul.row
          li(v-for="schedule in agenda.schedules", style="cursor: pointer")
            .col-xs-12.col-sm-1.title(v-tooltip="'Ver Detalhes'")
              i.fa.fa-clock-o(style="color: #ccc", aria-hidden='true', v-if="schedule.patient === 'Integração Medibook - Offline'") &nbsp;
              i.fa.fa-clock-o(aria-hidden='true', @click.prevent="setCurrentSchedule(schedule)", v-if="schedule.patient !== 'Integração Medibook - Offline'") &nbsp;
              | {{ schedule.time }}
            .col-xs-12.col-sm-4(v-if="schedule.patient === 'Integração Medibook - Offline'")
              |  {{ schedule.patient }}
            .col-xs-12.col-sm-4(v-if="schedule.patient !== 'Integração Medibook - Offline'")
                |  {{ schedule.patient.name }}
            .col-xs-12.col-sm-3
              | {{ schedule.covenant }}

            .col-xs-12.col-sm-3
              .input-group
                select.form-control.dropdown(name='schedule.id', key="schedule.id", @change='onSelectedRunAction(schedule.status, schedule)', v-model='schedule.status')
                  option.dropdown-content(v-for='(item, index) in schedule.otpions ', :value='item.value') {{item.text}}
                span.input-group-addon.blue-addon
                  span.icon 

            .col-xs-12.col-sm-1.text-center
                span.icon.transfer.mb-cursor-point(v-if="schedule.status === 'scheduled'", @click="doTransfer(schedule)", v-tooltip="'Transferir Paciente'") 
</template>
<style scoped>
.gadget .table ul li {
    color: #5d5d5d;
    list-style: none;
    padding: 6px 0px;
    overflow: hidden;
    cursor: default;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/app/professional/dashboard/company/gadget/components/schedulings/schedulings.vue